var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 529.11 287.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f846cb;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.33,268.3v19.6h-98V268.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,121.9v4.32H112.1v-3.74c0-6.92-3.75-12.25-13.55-12.25-8.21,0-12.53,4.18-12.53,10.52a9.47,9.47,0,0,0,4.18,8.36c2.73,1.87,7.92,4.46,15.27,7.49,9.8,3.6,16.71,7.64,20.61,11.81s5.9,10.09,5.9,17.73c0,17.29-13,27.52-33.28,27.52-22.91,0-33-11.1-33-27.81v-5.62H84.58v4c0,8.64,4.75,13.4,14.55,13.4,8.79,0,13.54-4,13.54-10.52,0-7.93-3.45-10.09-20.17-16.72-8.93-3.31-15.42-7.06-19.6-11.24S66.71,129,66.71,121c0-15.56,11.81-26.8,32.13-26.8C120.89,94.24,131,105.76,131,121.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.1,96h19.45v78.38h34v17.58H168.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.76,96h19.59v96H254.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,124.93v5.76H357.1v-4.75c0-9.8-5.19-15.28-13.83-15.28-9.66,0-15.28,7.21-15.28,18.59V158.5c0,11.38,5.62,18.73,15.28,18.73,8.64,0,13.83-5.47,13.83-15.27V157.2H376V163c0,19-11.53,31-32.86,31-21.9,0-35-13.83-35-35.88V129.83c0-22.05,13.69-35.88,35.45-35.88C365,94,376,105.48,376,124.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.77,96h57.49v17.14H424.79v21.76h30V151.3h-30v23.48h38.62v17.15H405.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.35 268.3 19.6 268.3 19.6 19.6 509.51 19.6 509.51 239.91 529.11 239.91 529.11 0 0 0 0 287.9 0 287.9 274.35 287.9 274.35 268.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlice);
export default __webpack_public_path__ + "static/media/Slice.2f1a2f235acd8ddc98f2b61f83f2b9e0.svg";
export { ForwardRef as ReactComponent };